import { ALL_FONT_FAMILY_OPTIONS } from 'components/editor/grid/reduxStore/defaultTextDefaultValue';
import { useMemo } from 'react';
import { useInstalledFonts } from './useInstalledFonts';

export function useAllAvailableFonts(contentId: string) {
  const { result: installedFonts } = useInstalledFonts(contentId);

  return useMemo(() => {
    const sortedInstalled = [...installedFonts].sort((a, b) => a.name.localeCompare(b.name));
    return Array.from(new Map([...ALL_FONT_FAMILY_OPTIONS, ...sortedInstalled].map((f) => [f.name, f])).values());
  }, [installedFonts]);
}
